import { memo, type ReactNode } from 'react';

export type ShareModalSectionLabelProps = {
  title: ReactNode;
};

export const ShareModalSectionLabel = memo(({ title }: ShareModalSectionLabelProps) => {
  return <h3 className="font-bold ads:text-metadata text-10 text-gray-10 uppercase tracking-wide">{title}</h3>;
});

ShareModalSectionLabel.displayName = 'ShareModalSectionLabel';
